import HeroContainerComponent from 'primitives/Hero/HeroContainer';
import styled from '@emotion/styled';

const HeroContainer = styled(HeroContainerComponent)({
  position: 'relative',
});

export default HeroContainer;
